import { Sun, Moon, Monitor } from "lucide-react";
import { useTheme } from "@/context/ThemeContext";

const opts = [
  ["light", Sun],
  ["dark", Moon],
  ["system", Monitor],
];

export const ThemeToggle = ({ style, className = "" }) => {
  const { theme, setTheme } = useTheme();
  return (
    <div
      className={`inline-flex items-center gap-0.5 rounded-full border p-0.5 ${className}`}
      style={{ borderColor: "currentColor", ...style }}
      data-testid="theme-toggle"
      role="group"
      aria-label="Theme mode"
    >
      {opts.map(([key, Icon]) => {
        const active = theme === key;
        return (
          <button
            key={key}
            type="button"
            onClick={() => setTheme(key)}
            data-testid={`theme-toggle-${key}`}
            aria-label={`${key} theme`}
            aria-pressed={active}
            className="rounded-full p-1.5 transition-all"
            style={active ? { backgroundColor: "var(--gold)", color: "#fff" } : { color: "currentColor", opacity: 0.7 }}
          >
            <Icon className="w-3.5 h-3.5" />
          </button>
        );
      })}
    </div>
  );
};
